export default __webpack_public_path__ + "static/media/noPagado.72cd6a3b.svg";